import { useState, useEffect } from 'react';
import { projectsService } from '../services/dataService';

/**
 * Custom hook to fetch projects from Firestore
 * @returns {Object} { projects, loading, error, refetch }
 */
export const useProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProjects = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await projectsService.getAll();
      
      if (result.success) {
        // Sort by order field
        const sortedProjects = result.data.sort((a, b) => (a.order || 0) - (b.order || 0));
        setProjects(sortedProjects);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  return {
    projects,
    loading,
    error,
    refetch: fetchProjects
  };
};